import { useEffect, useState } from "react";
import { FieldError, UseFormRegister } from "react-hook-form";
import { useAxios } from "../../utils/useAxios";
import { useFormData } from "../../context/FormDataContext";
interface CityAutocompleteProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  name: string;
  register: UseFormRegister<any>;
  error?: FieldError;
  validationRules?: object;
  selected?: any;
}

interface CityOption {
  id: number;
  city: string;
  state_name: string;
}

export function CityAutocomplete({
  name,
  register,
  error,
  validationRules,
  selected,
  ...rest
}: CityAutocompleteProps) {
  const [query, setQuery] = useState("");
  const [options, setOptions] = useState<CityOption[]>([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const [selectedCity, setSelectedCity] = useState(selected || "");

  const { setFormValue } = useFormData();

  const { formData } = useFormData();

  const {
    res,
    mutate,
    isPending,
    error: formError,
  } = useAxios({
    url: "/api/service/city",
  });

  useEffect(() => {
    const fetchCities = async () => {
      if (query.length < 2) {
        setShowDropdown(false);
        return;
      } // wait until 2+ characters
      mutate({
        name: query,
      });
    };

    const delayDebounce = setTimeout(fetchCities, 300);
    return () => clearTimeout(delayDebounce);
  }, [query]);

  useEffect(() => {
    if (res) {
      setOptions(res?.data?.list);
    }
  }, [res]);

  const handleSelect = (option: CityOption) => {
    setSelectedCity(option.city);
    setQuery(option.city);
    setShowDropdown(false);
    // manually update form value (important!)
    const event = {
      target: {
        name,
        value: option.city,
      },
    };
    rest?.onChange?.(event as any); // ensures RHF captures the selected value

    if (name === "city") {
      setFormValue("state", option.state_name); // context
      // Also notify RHF if state field exists
      const fakeStateEvent = {
        target: {
          name: "state",
          value: option.state_name,
        },
      };
      rest?.onChange?.(fakeStateEvent as any); // optional: depends if `register("state")` is in scope
    }
  };

  useEffect(() => {
    if (formData?.state) {
      if (name === "state") {
        setQuery(formData?.state);
      }
    }
  }, [formData]);

  return (
    <div className="relative">
      <input
        {...register(name, validationRules)}
        {...rest}
        autoComplete="off"
        value={query}
        onChange={(e) => {
          setQuery(e.target.value);
          setShowDropdown(true);
        }}
        //  onFocus={() => query && setShowDropdown(true)}
        //onBlur={() => setTimeout(() => setShowDropdown(false), 200)} // delay to allow click
        // placeholder="Type to search city"
        className="h-9 w-full border px-4 py-1 text-sm shadow-theme-xs placeholder:text-gray-400 focus:outline-none focus:ring bg-transparent text-gray-800 border-gray-300 focus:border-brand-300 focus:ring focus:ring-brand-500/10"
      />
      {showDropdown && options.length > 0 && (
        <ul className="absolute z-10 mt-1 w-full bg-white border border-gray-200 shadow-lg max-h-60 overflow-y-auto">
          {options.map((option) => (
            <li
              key={option.id}
              className="px-4 py-2 hover:bg-gray-100 cursor-pointer text-sm"
              onClick={() => handleSelect(option)}
            >
              {option?.city}, {option?.state_name}
            </li>
          ))}
        </ul>
      )}
      {formError && (
        <p className="text-red-500 text-sm mt-1">Failed to load options.</p>
      )}
    </div>
  );
}
